<template>
  <div class="card-tracking">
    <modal
      ref="resultsXmlModal"
      template="loading"
      title="Aguarde"
      ref-name="resultsXmlModal"
    >
      <p>Exportando resultados...</p>
    </modal>
    <card
      v-if="card.visible"
      :id="card.id"
      :key="card.id"
      :title="card.title"
      :subtitle-regular="getUpdateTime.phrase"
      :subtitle-highlight="getUpdateTime.time + ' (Período 7 dias)'"
      :buttons="card.buttons"
      :class="{ 'card-disabled': card.disabled }"
      class="flex justify-between"
      @click="callAction"
    >
      <div
        v-if="isLoadingCounters"
        class="loading-container"
      >
        <spinner class="medium" />
      </div>
      <component
        :is="card.component.name"
        v-else-if="card.component"
        :key="card.component.key"
        :content="content"
      />
      <infotip
        v-if="card.disabled"
        :id="card.id + '-disabled'"
        :key="card.id + '-infdotip-disabled'"
        :text="
          card.disabledMessage || 'A funcionalidade está temporariamente em manutenção.'
        "
        :auto-open-on-first-days="false"
        :never-open-again-after-dismissed="false"
        :close-on-mouse-leave="true"
      />
    </card>
    <redirect-external-links ref="redirector" />
  </div>
</template>

<script>
import Card from '../Card'
import Infotip from '@/components/common/infotip/Infotip'
import GraphicData from '../Widgets/GraphicData'
import { mapGetters, mapActions } from 'vuex'
import Moment from 'moment'
import RedirectExternalLinks from '@/components/common/RedirectExternalLinks'
import { RESULTS_RECENTS_DAYS_RANGE } from '@/enums'
import Spinner from '@/components/common/Spinner'

export default {
  name: 'CardTracking',
  components: {
    card: Card,
    infotip: Infotip,
    'graphic-data': GraphicData,
    'redirect-external-links': RedirectExternalLinks,
    spinner: Spinner,
  },
  data: () => ({
    daysRangeToGetResults: RESULTS_RECENTS_DAYS_RANGE,
  }),
  computed: {
    ...mapGetters([
      'getUpdateTime',
      'traceabilityGroupedExamsCount',
      'profile',
      'toggle',
      'loadingStatusFromTotalCounters',
      'loadingStatusFromSamplesPerPlaceExecution',
      'traceabilityCountersLoadingStatus',
      'getResultStatistics',
    ]),
    isLoadingCounters() {
      return (
        this.loadingStatusFromTotalCounters === 'STATUS_LOADING' ||
        this.loadingStatusFromSamplesPerPlaceExecution === 'STATUS_LOADING' ||
        this.traceabilityCountersLoadingStatus === 'STATUS_LOADING'
      )
    },
    content() {
      const counts = this.traceabilityGroupedExamsCount || {}

      let data = {
        graphicType: 'bar-chart',
        items: [
          {
            visible: true,
            number: this.toggle.sampleTraceability === true ? counts.TRIAGEM || 0 : 0,
            text: 'ENTREGUES AO NTO',
            traceabilityStatus: 'TRIAGEM',
            color: 'blue',
            sizeBig: true,
          },
          {
            visible: true,
            number: this.toggle.sampleTraceability === true ? counts.EM_EXECUCAO || 0 : 0,
            text: 'EXAMES EM EXECUÇÃO',
            traceabilityStatus: 'EM_EXECUCAO',
            color: 'yellow',
            sizeBig: true,
          },
          {
            visible: true,
            number:
              this.toggle.sampleTraceability === true
                ? (counts.LAUDO_LIBERADO || 0) +
                  (counts.FINALIZADO || 0) +
                  (counts.LAUDO_VISUALIZADO || 0)
                : 0,
            text: 'EXAMES LIBERADOS',
            traceabilityStatus: 'FINALIZADO',
            color: 'green',
            sizeBig: true,
          },
          {
            visible: true,
            number: this.toggle.sampleTraceability === true ? counts.ATRASADO || 0 : 0,
            text: 'EXAMES EM ATRASO',
            traceabilityStatus: 'ATRASADO',
            color: 'red',
            sizeBig: true,
          },
        ],
        NTOsLeft: [],
      }
      return data
    },
    card() {
      return {
        id: 'tracking',
        visible: true,
        disabled: !this.toggle.sampleTraceability,
        title: 'Rastreabilidade - produção',
        subtitleRegular: '',
        subtitleHighlight: '',
        updateTimeVisible: true,
        template: {
          flex: 70,
          column: 3,
          row: 2,
        },
        buttons: [
          {
            text: `(${this.getResultStatistics.resultsNewCount}) Resultados recentes não integrados`,
            style:
              this.getResultStatistics.resultsNewCount > 0
                ? 'btn-secondary-green'
                : 'btn-primary-gray',
            action:
              this.getResultStatistics.resultsNewCount > 0 ? 'Baixar novos laudos' : null,
            visible: !this.toggle.covax && this.toggle.results,
            image: '/static/images/icon-laudasa-results.svg',
            disabled: this.getResultStatistics.resultsNewCount === 0,
          },
          {
            text: 'Laudos em PDF',
            action: 'Laudos em PDF',
            style: 'btn-link-black',
            halfWidth: true,
            id: 'btnDashboardResultsExternal',
            visible: this.toggle.examResultsPDF,
            icon: '/static/images/icon-pdf-doc.svg',
          },
          {
            text: ' Resultados em XML',
            action: 'Resultados em XML',
            style: 'btn-link-black',
            id: 'btnDashboardResults',
            halfWidth: true,
            visible: !this.toggle.covax && this.toggle.results,
            icon: '/static/images/icon-xml-doc.svg',
          },
        ],
        component: {
          name: 'graphic-data',
          key: 2,
        },
      }
    },
  },
  methods: {
    ...mapActions([
      'exportResultByFilter',
      'selectResultList',
      'resetResultsStatistics',
      'updateResultsStatistics',
    ]),
    callAction(action) {
      if (
        action === 'Baixar novos laudos' &&
        this.getResultStatistics.resultsNewCount === 0
      ) {
        return
      }

      switch (action) {
        case 'Resultados em XML':
          this.$router.push('results')
          break
        case 'Baixar novos laudos':
          this.exportXmlResults()
          break
        case 'Laudos em PDF':
          this.openResultsPdfPage()
          break
      }
      this.$analytics.pushAnalyticsEvent('ga-event', {
        category: 'Dashboard Novo',
        action: action,
        'id-user': this.profile.id,
        'id-lab': this.profile.id_laboratory,
        'name-lab': this.profile.laboratoryName,
      })
    },
    exportXmlResults() {
      if (!this.profile.defaulter) {
        this.$refs.resultsXmlModal.open()
        this.selectResultList({
          startDate: Moment(new Date()).subtract(this.daysRangeToGetResults, 'days'),
          endDate: Moment(new Date()),
          exported: false,
          dateType: 'RD',
          integrated: null,
        })
        this.exportResultByFilter().then(downloadLink => {
          this.$refs.resultsXmlModal.close()

          if (downloadLink) {
            document.body.appendChild(downloadLink)
            downloadLink.click()

            this.resetResultsStatistics()
            this.updateResultsStatistics(this.daysRangeToGetResults)
          }
        })
      } else {
        this.$store.commit('RESULT_SET_OVERDUE', true)
      }
    },
    openResultsPdfPage() {
      this.$router.replace('/results-pdf')
    },
  },
}
</script>

<style lang="scss">
@media (max-width: 1080px) {
  .card-tracking {
    margin-bottom: 40px;
  }
}

.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 150px;
  padding: 20px;

  .loading-text {
    margin-top: 15px;
    color: #666;
    font-size: 14px;
    font-weight: 500;
    text-align: center;
  }
}

.spinner-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 250px;
  width: 100%;
}
</style>
